<template>
  <div id="success">
    <div class="success_icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" fill="#fff"/></svg>
    </div>
    <p>{{ getSuccessText }}</p>
  </div>
</template>

<script>
export default {
  name: 'Success',
  computed: {
    getSuccessText () {
      return this.$store.getters.getSuccessText
    }
  }
}
</script>

<style lang="scss" scoped>
  #success {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 12px;
    .success_icon {
      background: #41a811;
      max-width: 100px;
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      svg {
        width: 70%;
        height: auto;
      }
    }
    p {
      font-family: 'AvantGardeGothicC';
      font-size: 36px;
      text-align: center;
      color: #000000;
      line-height: normal;
      margin-top: 62px;
    }
  }
  @media only screen and (max-width: 768px) {
    #success {
      margin-top: -100px;
      p {
        font-size: 24px;
      }
    }
  }
</style>
